import { Pipe, PipeTransform } from '@angular/core';
import { IStock } from '../interfaces/IStock';
import { ISimpleListItem } from '../interfaces/ISimpleListItem';

@Pipe({
    name: 'stockByStore',
    standalone: false
})
export class StockByStorePipe implements PipeTransform {

    public transform(stocks: IStock[] | null | undefined, store: string | ISimpleListItem): number {
        if (!stocks?.length || store == null || store === '') {
            return 0;
        }

        if (typeof store === 'string') {
            return stocks.find(stock => stock.stockName === store)?.inStock || 0;
        }

        const byId = stocks.find(stock => Number(stock.storeId) === Number(store.id));
        if (byId) {
            return byId.inStock || 0;
        }

        return stocks.find(stock => stock.stockName === store.value)?.inStock || 0;
    }
}
